import {IconName, iconPaths} from '../icons/paths';

// The design's icon set (design/icons, via scripts/icons.mjs): 24px grid, round caps and joins,
// stroke currentColor. DESIGN.md §4: 1.75 stroke, 1.9 on small chips.
type Props = {
    name: IconName;
    size?: number;
    strokeWidth?: number;
    className?: string;
    label?: string;
};

export default function Icon({name, size = 24, strokeWidth, className, label}: Props) {
    const width = strokeWidth ?? (size <= 20 ? 1.9 : 1.75);
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={width}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden={label ? undefined : true}
            role={label ? 'img' : undefined}
            aria-label={label}
        >
            <path d={iconPaths[name]} />
        </svg>
    );
}
